import { Bar } from 'react-chartjs-2'

import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  LinearScale,
  Tooltip
} from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

// 左軸（件数）= 空色 / 右軸（比率）= 柿色
const LEFT_COLOR = '#6ECBFA'
const RIGHT_COLOR = '#FFB800'

interface Props {
  labels: string[]
  // 左Y軸の棒（件数など）
  leftBar: { title: string; values: number[] }
  // 右Y軸の棒（比率 0〜1）
  rightBar: { title: string; values: number[] }
  // チャート内蔵の凡例を表示するか（カード側で凡例を出す場合は false）
  showLegend?: boolean
}

const DualAxisBarChart = ({ labels, leftBar, rightBar, showLegend = true }: Props) => {
  const options: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { top: 20 } },
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: {
        display: showLegend,
        position: 'top',
        align: 'end',
        labels: {
          color: '#34414F',
          font: { size: 12 },
          boxWidth: 8,
          boxHeight: 8,
          padding: 16,
          usePointStyle: true,
          pointStyle: 'rect'
        }
      },
      tooltip: {
        backgroundColor: 'rgba(2, 6, 23, 0.95)',
        titleFont: { family: "'JetBrains Mono', monospace", size: 11, weight: 'bold' },
        bodyFont: { family: "'JetBrains Mono', monospace", size: 11 },
        padding: 8,
        cornerRadius: 4,
        displayColors: true,
        callbacks: {
          label: (ctx) => {
            const value = ctx.parsed.y ?? 0
            if (ctx.dataset.yAxisID === 'y1') {
              return `${ctx.dataset.label}: ${(value * 100).toFixed(2)}%`
            }
            return `${ctx.dataset.label}: ${value.toLocaleString()}`
          }
        }
      }
    },
    scales: {
      x: {
        grid: { display: false },
        border: { display: false },
        ticks: { font: { size: 10 }, color: '#34414F', maxRotation: 0 }
      },
      y: {
        beginAtZero: true,
        border: { display: false },
        grid: { color: '#E4E8EE' },
        ticks: { font: { size: 10 }, color: '#34414F', padding: 6, count: 6 }
      },
      y1: {
        type: 'linear',
        position: 'right',
        beginAtZero: true,
        max: 1,
        border: { display: false },
        grid: { drawOnChartArea: false },
        ticks: { font: { size: 10 }, color: '#34414F', padding: 6, count: 6 }
      }
    }
  }

  return (
    <Bar
      data={{
        labels,
        datasets: [
          {
            label: leftBar.title,
            data: leftBar.values,
            backgroundColor: LEFT_COLOR,
            borderRadius: 2,
            borderSkipped: false,
            yAxisID: 'y'
          },
          {
            label: rightBar.title,
            data: rightBar.values,
            backgroundColor: RIGHT_COLOR,
            borderRadius: 2,
            borderSkipped: false,
            yAxisID: 'y1'
          }
        ]
      }}
      options={options}
    />
  )
}

export default DualAxisBarChart
